/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSimulationPricingsIndividualHealthQuery from '../graphql/queries/GetSimulationPricingsIndividualHealthQuery.js';

const useGetSimulationPricingsIndividualHealthQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSimulationPricingsIndividualHealthQuery, args);

  return {
    error,
    loading,
    refetch,
    getSimulationPricingsIndividualHealth: R.omit(['__typename'], data?.getSimulationPricingsIndividualHealth_simulation_pricings_individual_health || {})
  };
};

export default useGetSimulationPricingsIndividualHealthQuery;
